<template>
  <div class="create-section">
    <div v-if="selectedSection" class="create-section__title">Edit Section</div>
    <div v-else class="create-section__title">Create New Section</div>
    <label class="create-section__input">
      <span class="create-section__label">Active</span>
      <div class="create-section__link-wrapper"
           :class="{'create-section__link-wrapper_single': isDomainDropdownHidden}">
        <base-select
          border-less="true"
          class="create-section__active"
          :disabled="disableButtons"
          :options="data.opts.is_active"
          v-model="section.is_active"
          alignLeft="true"
          :max-height-list="450"
          :titleStyle="titleStyle"
          :headerStyle="selectTypeStyle"
        />
      </div>
    </label>
    <label class="create-section__input">
      <span class="create-section__label">Name</span>
      <div class="create-section__link-wrapper"
           :class="{'create-section__link-wrapper_single': isDomainDropdownHidden}">
        <input type="text"
               :disabled="disableButtons"
               class="form-control create-section__link-field"
               placeholder="Enter the Name for this section"
               :class="{'form-control_error': externalErrors.name}"
               v-model="section.name">
        <span class="create-section__error-message" v-if="externalErrors.name">{{externalErrors.name}}</span>
      </div>
    </label>
    <label class="create-section__input">
      <span class="create-section__label">Rank Report Targeting - GEO</span>
      <div class="create-section__link-wrapper"
           :class="{'create-section__link-wrapper_single': isDomainDropdownHidden}">
        <base-select
          border-less="true"
          class="create-section__active"
          :disabled="disableButtons"
          :options="data.opts.target_geo"
          v-model="section.fk_rank_report_param_id_geo"
          alignLeft="true"
          isSmartInput
          :max-height-list="450"
          :titleStyle="titleStyle"
          :headerStyle="selectTypeStyle"
        />
      </div>
    </label>
    <label class="create-section__input">
      <span class="create-section__label">Rank Report Targeting - Device</span>
      <div class="create-section__link-wrapper"
           :class="{'create-section__link-wrapper_single': isDomainDropdownHidden}">
        <base-select
          border-less="true"
          class="create-section__active"
          :disabled="disableButtons"
          :options="data.opts.target_device"
          v-model="section.fk_rank_report_param_id_device"
          alignLeft="true"
          :max-height-list="450"
          :titleStyle="titleStyle"
          :headerStyle="selectTypeStyle"
        />
      </div>
    </label>
    <label class="create-section__input">
      <span class="create-section__label">Rank Report Targeting - Locale</span>
      <div class="create-section__link-wrapper"
           :class="{'create-section__link-wrapper_single': isDomainDropdownHidden}">
        <base-select
          border-less="true"
          class="create-section__active"
          :disabled="disableButtons"
          :options="data.opts.target_locale"
          v-model="section.fk_rank_report_param_id_locale"
          alignLeft="true"
          isSmartInput
          :max-height-list="450"
          :titleStyle="titleStyle"
          :headerStyle="selectTypeStyle"
        />
      </div>
    </label>
    <div class="create-section__controls">
      <button class="create-section__button create-section__button_cancel"
              :class="{'create-section__button_disabled': disableButtons}"
              @click.prevent="close()">Cancel
      </button>
      <button v-if="selectedSection" class="create-section__button create-section__button_delete"
              :class="{'create-section__button_disabled': disableButtons}"
              @click.prevent="openConfirmModal()">
        Delete
      </button>
      <button class="create-section__button create-section__button_submit"
              :class="{'create-section__button_disabled': disableButtons}"
              @click.prevent="apply()">
        Apply
      </button>
    </div>
    <modal name="confirm-modal" v-bind="modalProps">
      <base-confirm-modal title="Are you sure you want to delete this?"
                          subtitle="This Section will be removed permanently!"
                          @confirm="confirmModal"/>
    </modal>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import _ from 'lodash'
import baseModalProps from '@/common/BaseModalProps'
import BaseModalMixins from '@/common/BaseModalMixins'

const SELECT_STYLE = {
  'background-color': 'transparent',
  color: '#284aff',
  'text-decoration': 'underline'
}

export default {
  name: 'CreateUpdateSectionPopup',
  mixins: [BaseModalMixins],
  props: {
    selectedSection: {
      type: Object
    },
    data: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      section: _.cloneDeep(this.selectedSection) || {
        id: -1,
        is_active: this.data.defaultSection.is_active || 1,
        name: '',
        fk_rank_report_param_id_device: this.data.defaultSection.target_device || -1,
        fk_rank_report_param_id_geo: this.data.defaultSection.target_geo || -1,
        fk_rank_report_param_id_locale: this.data.defaultSection.target_locale || -1
      },
      errorFields: [],
      disableButtons: false,
      externalErrors: {
        name: null
      },
      isValidating: false,
      isDomainDropdownHidden: true,
      elementStyle: {},
      titleStyle: {
        overflow: 'visible'
      },
      selectTypeStyle: _.cloneDeep(SELECT_STYLE)
    }
  },
  watch: {
    'section.name' (v) {
      this.section.name = v.toLowerCase()
    }
  },
  computed: {
    modalProps () {
      return { ...baseModalProps, height: 'auto', width: '510px' }
    }
  },
  methods: {
    ...mapActions('sections', ['validate']),
    close () {
      this.$emit('cancel')
    },
    convertToOptions (item) {
      return {
        value: item._id,
        label: item.label
      }
    },
    showErrors (errors) {
      for (const k in this.externalErrors) {
        this.externalErrors[k] = null
      }

      for (const k in errors) {
        this.externalErrors[k] = errors[k]
      }
    },
    confirmModal (status) {
      this.$modal.hide('confirm-modal')
      if (status) {
        this.deleteSection()
      }
    },
    openConfirmModal () {
      this.$modal.show('confirm-modal')
    },
    async apply () {
      this.disableButtons = true
      const response = await this.validate({
        clientId: this.clientId,
        section: JSON.stringify({ ...this.section, name: this.section.name.trim() })
      })
      this.disableButtons = false
      if (!Object.keys(response.error_fields).length) {
        this.$emit('apply', { ...this.section, name: this.section.name.trim() })
      } else {
        this.externalErrors = { ...this.externalErrors, ...response.error_fields }
      }
    },
    deleteSection () {
      this.$emit('delete', this.section.id)
    }
  }
}
</script>

<style lang="scss">
.create-section {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  padding: 40px;

  .v--modal-overlay {
    background-color: transparent !important;
  }

  &__title {
    text-align: center;
    font-size: 34px;
    font-weight: 500;
    margin: 9px 0 35px;
    color: $rfx-dark-march;
  }

  &__input {
    display: flex;
    flex-direction: column;
    position: relative;
    margin-top: 30px;

    &_invalid[type='text'] {
      border: 1px solid $rfx-red;
      border-radius: 4px;
    }
  }

  &__label {
    display: block;
    font-weight: 600;
    margin-bottom: 5px;
    color: $rfx-dark-march;
  }

  &__controls {
    display: flex;
    justify-content: flex-end;
    margin-top: 30px;
  }

  &__button {
    width: 100px;
    height: 40px;
    border-radius: 4px;
    font-size: 10px;
    font-weight: 900;
    text-transform: uppercase;
    margin-left: 30px;
    border: none;
    outline: none;
    cursor: pointer;

    &_submit {
      background-color: $rfx-medium-march;
      color: #fff;

      &:disabled {
        pointer-events: none;
        background-color: #fff;
        color: $rfx-neutral-grey;
        cursor: default;
      }
    }

    &_delete {
      background-color: $rfx-red;
      color: #fff
    }

    &_disabled {
      pointer-events: none;
      opacity: 0.4;
      cursor: default;
    }

    &_cancel {
      color: $rfx-dark-march;
      background-color: #fff;
    }
  }

  &__link {
    &-wrapper {
      position: relative;
      margin-top: 30px;

      &_single {
        margin-top: 0;
      }
    }

    &-field[type='text'] {
      width: 100%;
      box-sizing: border-box;
      padding-right: 60px;
      font-weight: 500;
      @include ellipsis;
    }
  }

  &__error-message {
    color: $rfx-red;
    font-size: 10px;
    margin-top: 5px;
  }

}

.form-control {
  height: 50px;
  padding: 0 20px;
  border: 2px solid $rfx-light-steel;
  outline: none;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 600;
  color: $rfx-dark-march;

  &::placeholder {
    color: $rfx-pearl;
    font-weight: normal;
    font-size: 14px;
  }

  &:disabled {
    background-color: $rfx-light-steel;
  }

  &_error {
    border-color: $rfx-red;
    color: $rfx-red;

    &::placeholder {
      color: $rfx-red;
      font-size: 13px;
    }

  }
}

</style>
